import { render, staticRenderFns } from "./ClicImageInterno.vue?vue&type=template&id=568dec9e&"
import script from "./ClicImageInterno.vue?vue&type=script&lang=js&"
export * from "./ClicImageInterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports